module.exports = __webpack_public_path__ + "img/project-13.7c46910c.jpg";